import Facade from '@/Facade'
import GameSignals from '@/signals/GameSignals'
import { GameStatesEnum } from '@/states/GameStatesEnum'
import { RoundRestoreUtil } from '@/utils/RoundRestoreUtil'
import { BaseState } from '@stateMachine/BaseState'
import { GambleFlowManager } from '@dragonframework/modules'

export class StopRoundState extends BaseState {
    public begin() {
        RoundRestoreUtil.stopRound()

        // if (this._model.roundState.isRestoredRound) {
        //     this._model.resetCurrentBet()
        // }

        const spinBalance = this._model.spinData?.balance || 0
        const finalBalance = spinBalance > 0
            ? this._model.balance
            : this._model.balance
                - (this._model.roundState.isFreeSpins ? 0 : (this._model.bonusBuyBet ?? this._model.currentBet) / 100)
                + (this._model.winCurrency || 0)
        GameSignals.balanceHasChanged.emit(finalBalance)
        this._model.winCounter.stopRound()
        GameSignals.roundStop.emit()

        if (!this._model.freeRoundsActive() && this._model.spinData.freeround) {
            GameSignals.changeDialogState.connect(this.onChangeDialogState)
        } else {
            this.end()
        }
    }

    private onChangeDialogState = (isDialogShown: boolean) => {
        if (!isDialogShown) {
            GameSignals.unLockGamePanel.emit()
            this._stateMachine.setState(GameStatesEnum.IDLE_STATE)
        }
    }

    public end = () => {
        if (GambleFlowManager.isActive()) {
            this._stateMachine.setState(GameStatesEnum.GAMBLE_STATE)
            return
        }

        if (Facade.isAuto || this._model.spinState.isIdleStateWinSkipped) {
            const nextRoundDelay = (this._model.spinData.win_currency === 0) ? 500 : 0
            setTimeout(this.onStartNextRound, nextRoundDelay)
        } else {
            this._stateMachine.setState(GameStatesEnum.IDLE_STATE)
        }
    }

    public cleanUp() {
        GameSignals.changeDialogState.disconnect(this.onChangeDialogState)
    }

    private onStartNextRound = () => {
        if (Facade.requestOngoing) {
            window.setTimeout(this.onStartNextRound, 100)
        } else {
            this._stateMachine.setState(GameStatesEnum.START_ROUND_STATE)
        }
    }
}
